import React, { useEffect, useState } from "react";
import { CreateExpenseSvg } from "../../svgFiles/CreateExpenseSvg";
import { CopySvg } from "../../svgFiles/CopySvg";
import "./expense.css";
import BlankIMage from "../../images/blank_image.png";
import { Image } from "react-bootstrap";
import { UploadSimpleSvg } from "../../svgFiles/UploadSimpleSvg";
import { Row, Col } from "react-bootstrap";
import SelectBox from "../../components/shared/fields/SelectBox ";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import TextareaWithLabel from "../../components/shared/fields/TextareaWithLabel";
import Button from "../../components/shared/buttons/button";
import Datatable from "../../components/shared/datatable/Datatable";
import { EditSvg } from "../../svgFiles/EditSvg";
import { DeleteSvg } from "../../svgFiles/DeleteSvg";
import { formatNumber, getBase64, getCurrentDate, getCurrentDateTime, showToast } from "../../helpers/Utils";
import {
  useCreateExpenseMutation,
  useGetExpenseByIdQuery,
  useGetExpenseTypesQuery,
  useGetNextAvailableBillNumberQuery,
  useGetSupplierDetailsQuery,
  useGetSuppliersListQuery,
  useUpdateExpenseMutation,
} from "./expenseApi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { decrypt } from "../../helpers/decrypt";
import moment from "moment";
import { LeftArrowSvg } from "../../svgFiles/LeftArrowSvg";
import { LeftChevronSvg } from "../../svgFiles/LeftChevronSvg";
import useTranslator from "../../hooks/useTranslator";
import usePermissions from "../../hooks/usePermissions";
import { validatePhoneNumber } from "../../helpers/phoneValidation";
const initialFormData = {
  file: null,
  expenses: [],
  vendor_name: "",
  bill_number: "",
  vendor_email: "",
  vendor_phone: "",
  bill_date: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
  due_date: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
  vendor_address: "",
  description: "",
  // Bank details
  bank_account_holder_name: "",
  bank_name: "",
  bank_account_number: "",
  bank_rfc: "",
  bank_concept: "",
  is_registered: "",
};

const initialExpense = {
  expense_type: "",
  description: "",
  amount: "",
};

const today = getCurrentDate("YYYY-MM-DD");

const Billcreation = () => {
  const { _t } = useTranslator();
  const columns = [
    { label: _t("expense_type", "Expense Type"), accessor: "expense_type" },
    { label: _t("description", "Description"), accessor: "description" },
    {
      label: _t("amount", "Amount"),
      accessor: "amount",
      cell: ({ row, value }) => `$${formatNumber(value)}`,
    },
    {
      label: _t("actions", "Actions"),
      accessor: "actions",
      cell: ({ row, value, index }) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => handleDelete(row, index)}
          >
            {DeleteSvg}
          </span>
        );
      },
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams(); // Get id from URL params
  const isEditMode = !!id; // Check if we're in edit mode

  // States
  const [formData, setFormData] = useState(initialFormData);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileName, setPdfFileName] = useState("No file selected");
  const [currentExpense, setCurrentExpense] = useState(initialExpense);
  const [editingIndex, setEditingIndex] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  // Fetch expense data if in edit mode
  const {
    data: expenseData,
    isLoading: isLoadingExpense,
    error: expenseError,
  } = useGetExpenseByIdQuery(id, {
    skip: !isEditMode, // Skip if not in edit mode
  });

  const [createExpense, { isLoading: isCreating }] = useCreateExpenseMutation();
  const [updateExpense, { isLoading: isUpdating }] = useUpdateExpenseMutation();

  const isLoading = isCreating || isUpdating;

  const {
    data: suppliers,
    isLoading: getSupplierLoading,
    error,
  } = useGetSuppliersListQuery();
  const {
    data: expenseTypes,
    isLoading: getexpenseTypesLoading,
    error: expenseTypesError,
  } = useGetExpenseTypesQuery();
  const {
    data: supplierData,
    isLoading: isLoadingSupplierData,
    error: isLoadingSupplierError,
  } = useGetSupplierDetailsQuery(selectedSupplierId, {
    skip: !selectedSupplierId, // don't call if no ID selected
  });

  const {
    data: billNumberData,
    isLoading: isLoadingBillNumber,
    refetch,
  } = useGetNextAvailableBillNumberQuery(undefined, {
    refetchOnFocus: true,
  });

  // Populate form data when expense data is fetched (for edit mode)
  useEffect(() => {
    if (isEditMode && expenseData?.data) {
      const expense = expenseData.data;      

      setFormData({
        vendor_name: expense.vendor_name || "",
        bill_number: expense.bill_number || "",
        vendor_email: expense.vendor_email || "",
        vendor_phone: expense.vendor_phone || "",
        bill_date: expense.bill_date || "",
        due_date: expense.due_date || "",
        vendor_address: expense.vendor_address || "",
        description: expense.description || "",
        // Bank details
        bank_account_holder_name: expense.bank_account_holder_name || "",
        bank_name: decrypt(expense.bank_name) || "",
        bank_account_number: decrypt(expense.bank_account_number) || "",
        bank_rfc: expense.bank_rfc || "",
        bank_concept: expense.bank_concept || "",
        expenses: expense.items || [],
        file: null, // We don't set the file directly
        is_registered: expense.is_registered || "",
      });

      // Set the invoice URL if available
      if (expense.invoice_file_url) {
        setInvoiceUrl(expense.invoice_file_url);
        setPdfFileName("Current Invoice");
      }

      // Calculate total amount from expenses
      if (expense.items && expense.items.length > 0) {
        calculateTotalAmount(expense.items);
      }
    } else {
      setFormData(initialFormData);
      setCurrentExpense(initialExpense);
      setSelectedSupplierId(null);
      setInvoiceUrl(null);
      setPdfFileName(_t("no_file_selected", "No file selected"));
      setTotalAmount(0);
    }
  }, [isEditMode, expenseData]);

  const location = useLocation();

  useEffect(() => {
    refetch();
  }, [location.pathname]);

  const handleChangeVendor = (e) => {
    const { name, value } = e.target;
    setSelectedSupplierId(value);
    handleInputChange(e);
  };

  // Handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const addExpenseHandler = () => {
    if (
      !currentExpense.expense_type ||
      !currentExpense.description ||
      !currentExpense.amount
    ) {
      showToast(
        _t("fill_all_expense_fields", "Please fill all expense fields!"),
        "error"
      );
      return;
    }

    if (editingIndex !== null) {
      // Update existing expense
      setFormData((prevFormData) => {
        const updatedExpenses = [...prevFormData.expenses];
        updatedExpenses[editingIndex] = currentExpense;
        return { ...prevFormData, expenses: updatedExpenses };
      });

      // Calculate new total after updating expense
      const updatedExpenses = [...formData.expenses];
      updatedExpenses[editingIndex] = currentExpense;
      calculateTotalAmount(updatedExpenses);
    } else {
      // Add new expense
      setFormData((prevFormData) => ({
        ...prevFormData,
        expenses: [...prevFormData.expenses, currentExpense],
      }));

      // Calculate new total after adding expense
      calculateTotalAmount([...formData.expenses, currentExpense]);
    }

    // Reset after add or update
    setCurrentExpense(initialExpense);
    setEditingIndex(null);
  };

  useEffect(() => {
    if (supplierData?.data) {
      setFormData((prev) => ({
        ...prev,
        bank_account_holder_name:
          supplierData?.data?.bank_account_holder_name || "",
        vendor_address: supplierData?.data?.vendor_address || "",
        vendor_email: supplierData?.data?.vendor_email || "",
        vendor_phone: supplierData?.data?.vendor_phone || "",
        bank_name: supplierData?.data?.bank_name || "",
        bank_account_holder_name:
          supplierData?.data?.bank_account_holder_name || "",
        bank_account_number: supplierData?.data?.bank_account_number || "",
        bank_rfc: supplierData?.data?.bank_rfc || "",
        bank_concept: supplierData?.data?.bank_concept || "",
        is_registered: supplierData?.data?.is_registered,
      }));
    }
  }, [supplierData]);

  useEffect(() => {
    // Only set bill number from API if not in edit mode
    if (billNumberData?.data && !isEditMode) {
      setFormData((prev) => ({
        ...prev,
        bill_number: billNumberData?.data || "",
      }));
    }
  }, [billNumberData, isEditMode]);

  const calculateTotalAmount = (expenses) => {
    const total = expenses.reduce((sum, expense) => {
      return sum + (parseFloat(expense.amount) || 0);
    }, 0);
    setTotalAmount(total);
  };

  const handleEdit = (expense, indexToEdit) => {
    const expenseToEdit = formData.expenses[indexToEdit];
    setCurrentExpense(expenseToEdit);
    setEditingIndex(indexToEdit);
  };

  const handleDelete = (expense, indexToDelete) => {
    const updatedExpenses = formData.expenses.filter(
      (_, index) => index !== indexToDelete
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      expenses: updatedExpenses,
    }));

    // Recalculate total after deletion
    calculateTotalAmount(updatedExpenses);

    if (editingIndex === indexToDelete) {
      setCurrentExpense(initialExpense);
      setEditingIndex(null);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file type - only allow PDF
      if (file.type !== "application/pdf") {
        showToast(
          _t("only_pdf_allowed", "Only PDF files are allowed."),
          "error"
        );
        return;
      }

      try {
        setPdfFileName(file.name);
        setPdfFile(URL.createObjectURL(file));
        setFormData((prev) => ({
          ...prev,
          file,
        }));
        // Clear the previous invoice URL since we're uploading a new file
        setInvoiceUrl(null);
      } catch (error) {
        showToast(error.message, "error");
      }
    }
  };

  const handleViewInvoice = () => {
    if (invoiceUrl) {
      window.open(invoiceUrl, "_blank");
    }
  };

  const validateForm = () => {
    // Required fields validation
    const requiredFields = [
      { name: "vendor_name", label: _t("vendor_name", "Vendor Name") },
      { name: "vendor_phone", label: _t("phone_number", "Phone Number") },
      { name: "bill_date", label: _t("bill_date", "Bill Date") },
      { name: "due_date", label: _t("due_date", "Due Date") },
      {
        name: "bank_account_holder_name",
        label: _t("account_name", "Account Name"),
      },
      { name: "bank_name", label: _t("bank_name", "Bank Name") },
      {
        name: "bank_account_number",
        label: _t("account_number", "Account Number"),
      },
    ];

    // Validate phone number format
    const phoneValidation = validatePhoneNumber(formData.vendor_phone);
    if (!phoneValidation.isValid) {
      setFormErrors({ vendor_phone: phoneValidation.error });
      showToast(phoneValidation.error, "error");
      return false;
    }

    for (const field of requiredFields) {
      if (!formData[field.name]) {
        showToast(`${field.label} is required`, "error");
        return false;
      }
    }

    // Validate if at least one expense is added
    if (formData.expenses.length === 0) {
      showToast(
        _t("add_at_least_one_expense", "Please add at least one expense"),
        "error"
      );
      return false;
    }

    // Validate if an invoice has been uploaded (only required for new expenses)
    if (!isEditMode && !formData.file) {
      // showToast(
      //   _t("upload_invoice_pdf", "Please upload an invoice PDF"),
      //   "error"
      // );
      // return false;
    }

    setFormErrors({});
    return true;
  };

  const handleSaveChanges = async () => {
    // Validate form before submitting
    if (!validateForm()) {
      return;
    }

    try {
      // Create FormData for multipart/form-data submission (for file upload)
      const formDataPayload = new FormData();

      // Add all text fields
      formDataPayload.append("vendor_name", formData.vendor_name);
      formDataPayload.append(
        "bill_number",
        isEditMode ? formData.bill_number : billNumberData?.data
      );
      formDataPayload.append("vendor_email", formData.vendor_email);
      formDataPayload.append("vendor_phone", formData.vendor_phone);
      formDataPayload.append("bill_date", formData.bill_date);
      formDataPayload.append("due_date", formData.due_date);
      formDataPayload.append("vendor_address", formData.vendor_address);
      formDataPayload.append("description", formData.description);

      // Bank details
      formDataPayload.append(
        "bank_account_holder_name",
        formData.bank_account_holder_name
      );
      formDataPayload.append("bank_name", formData.bank_name);
      formDataPayload.append(
        "bank_account_number",
        formData.bank_account_number
      );
      formDataPayload.append("bank_rfc", formData.bank_rfc);
      formDataPayload.append("concept", formData.bank_concept);

      // Add file only if a new one was selected
      if (formData.file) {
        formDataPayload.append("invoice", formData.file);
      }

      formDataPayload.append("is_registered", formData.is_registered);

      // Add expenses as JSON string
      const expensesWithNumericAmount = formData.expenses.map((expense) => ({
        ...expense,
        amount: parseFloat(expense.amount),
      }));

      // Append each expense as a separate field in the format the API expects
      expensesWithNumericAmount.forEach((expense, index) => {
        formDataPayload.append(
          `expenses[${index}][expense_type]`,
          expense.expense_type
        );
        formDataPayload.append(
          `expenses[${index}][description]`,
          expense.description
        );
        formDataPayload.append(`expenses[${index}][amount]`, expense.amount);
      });

      // Add total amount
      formDataPayload.append("total_amount", totalAmount.toString());

      let response;
      if (isEditMode) {
        // Update existing expense
        response = await updateExpense({
          id,
          requestBody: formDataPayload,
        }).unwrap();
      } else {
        // Create new expense
        response = await createExpense(formDataPayload).unwrap();
      }

      // showToast(response?.message || "Operation successful", "success");

      // Force refreshed listing so newly saved data is immediately visible.
      window.location.assign("/bill-listing");
      // Reset form after successful submission
      setFormData(initialFormData);
      setPdfFile(null);
      setPdfFileName(_t("no_file_selected", "No file selected"));
      setTotalAmount(0);
    } catch (err) {
      console.error(
        `Failed to ${isEditMode ? "update" : "create"} expense:`,
        err
      );
      // showToast(
      //   `Failed to ${
      //     isEditMode ? "update" : "create"
      //   } expense. Please try again.`,
      //   "error"
      // );
    }
  };

  // Show loading state while fetching expense data
  if (isEditMode && isLoadingExpense) {
    return (
      <div className="text-center mt-5">
        {_t("loading_expense_data", "Loading expense data...")}
      </div>
    );
  }

  // Show error if expense data fetch fails
  if (isEditMode && expenseError) {
    return (
      <div className="text-center mt-5 text-danger">
        {_t(
          "error_loading_expense_data",
          "Error loading expense data. Please try again."
        )}
      </div>
    );
  }

  return (
    <>
      <div className="cmn_card">
        <div className="bill_head d-flex gap-3 align-items-center">
          <div className="flex-grow-1">
            <h6 className="m-0 d-flex align-items-center">
              {isEditMode ? (
                <span
                  onClick={() => {
                    navigate("/bill-listing");
                  }}
                  className="cursor-pointer me-2"
                >
                  {LeftChevronSvg}
                </span>
              ) : (
                <CreateExpenseSvg className="me-2" />
              )}
              {isEditMode
                ? _t("edit_expense", "Edit Expense")
                : _t("create_new_expense", "Create New Expense")}
            </h6>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="m-0">{_t("bill_number", "Bill Number")}</h6>
            <span className="copy_bill">
              <CopySvg />{" "}
              {isEditMode
                ? formData.bill_number
                : billNumberData?.data
                ? billNumberData?.data
                : "Loading.."}
            </span>
          </div>
        </div>

        <div className="details_expense">
          <div className="upload_invoice mb-4">
            <h5 className="invoice_heading">
              {_t("upload_invoice", "Upload Invoice")} ({_t("pdf", "PDF")})
            </h5>
            <div className="upload_wrapper d-flex gap-3 align-items-center">
              <div
                className="pdf-preview"
                style={{
                  width: "220px",
                  height: "220px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                  borderRadius: "5px",
                }}
              >
                {pdfFile || invoiceUrl ? (
                  <div className="pdf-icon" style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "48px", color: "#ff0000" }}>
                      {_t("pdf", "PDF")}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        marginTop: "10px",
                        wordBreak: "break-word",
                        padding: "0 10px",
                      }}
                    >
                      {pdfFileName}
                    </div>
                  </div>
                ) : (
                  <span>{_t("no_pdf_selected", "No PDF selected")}</span>
                )}
              </div>
              <div className="upload_inpout">
                <span className="d-inline-block upload_text">
                  {_t("upload_invoice_here", "Upload your Invoice here")}{" "}
                  <span className="format">
                    {_t("pdf_format_only", "PDF format only")}
                  </span>
                </span>
                <div className="upload_input mt-3 cursor-pointer">
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    className="mw-100"
                  />
                  <span>
                    {_t("upload_invoice", "Upload Invoice")} <UploadSimpleSvg />
                  </span>
                </div>
                {invoiceUrl && (
                  <div className="mt-3">
                    <Button
                      label={_t("view_invoice", "View Invoice")}
                      onClick={handleViewInvoice}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <Row>
            <Col lg={6}>
              <h5 className="invoice_heading">
                {_t("expense_details", "Expense Details")}
              </h5>
              <div className="card_brodered">
                {/* <SelectBox
                  label="Supplier"
                  name="vendor_name"
                  value={formData.vendor_name}
                  onChange={handleChangeVendor}
                  options={
                    suppliers?.data?.map((supplier) => ({
                      value: supplier.id,
                      label: supplier.vendor_name,
                    })) || []
                  }
                  required
                /> */}
                <InputWithLabel
                  label={_t("vendor", "Vendor")}
                  type="text"
                  name="vendor_name"
                  placeholder={_t("vendor", "Vendor")}
                  value={formData.vendor_name}
                  onChange={handleInputChange}
                  required
                />
                <InputWithLabel
                  label={_t("email_address", "Email Address")}
                  type="text"
                  name="vendor_email"
                  placeholder="Febysabilhul@gmail.com"
                  value={formData.vendor_email}
                  onChange={handleInputChange}
                />
                <InputWithLabel
                  label={_t("phone_number", "Phone Number")}
                  type="mobile"
                  name="vendor_phone"
                  placeholder="e.g. +1 202-555-0143"
                  value={formData.vendor_phone}
                  onChange={handleInputChange}
                  error={formErrors.vendor_phone}
                  required
                />
                <Row>
                  <Col lg={6}>
                    <InputWithLabel
                      label={_t("bill_date", "Bill Date")}
                      type="datetime-local"
                      name="bill_date"
                      value={formData.bill_date}
                      onChange={handleInputChange}
                      max={today}
                      required
                    />
                  </Col>
                  <Col lg={6}>
                    <InputWithLabel
                      label={_t("bill_due_date", "Bill Due Date")}
                      type="datetime-local"
                      name="due_date"
                      value={formData.due_date}
                      onChange={handleInputChange}
                      min={formData.bill_date}
                      required
                    />
                  </Col>
                </Row>
                <TextareaWithLabel
                  label={_t("address", "Address")}
                  name="vendor_address"
                  placeholder={_t("write_address_here", "Write address here")}
                  value={formData.vendor_address}
                  onChange={handleInputChange}
                />
                <TextareaWithLabel
                  label={_t("description", "Description")}
                  name="description"
                  placeholder={_t(
                    "write_description_here",
                    "Write description here"
                  )}
                  rows={3}
                  value={formData.description}
                  onChange={handleInputChange}
                />
                <SelectBox
                  className={"w-100"}
                  label={_t("is_registered", "Is Registered")}
                  name="is_registered"
                  options={[
                    {
                      value: 1,
                      label: _t("yes", "Yes"),
                    },
                    {
                      value: 0,
                      label: _t("no", "No"),
                    },
                  ]}
                  value={formData.is_registered}
                  onChange={handleInputChange}
                />
              </div>
            </Col>
            <Col lg={6}>
              <h5 className="invoice_heading">
                {_t("bank_account_details", "Bank Account Details")}
              </h5>
              <div className="card_brodered">
                <InputWithLabel
                  label={_t("name", "Name")}
                  type="text"
                  name="bank_account_holder_name"
                  placeholder={_t("name", "Name")}
                  value={formData.bank_account_holder_name}
                  onChange={handleInputChange}
                  required
                />

                <InputWithLabel
                  label={_t("bank_name", "Bank Name")}
                  type="text"
                  name="bank_name"
                  placeholder={_t("enter_bank_name", "Enter Bank Name")}
                  value={formData.bank_name}
                  onChange={handleInputChange}
                  required
                />

                <InputWithLabel
                  label={_t("account_number", "Account Number")}
                  type="text"
                  name="bank_account_number"
                  placeholder={_t("account_number", "Account Number")}
                  value={formData.bank_account_number}
                  onChange={handleInputChange}
                  required
                />
                <InputWithLabel
                  label="RFC"
                  type="text"
                  name="bank_rfc"
                  placeholder={_t("rfc_Number", "RFC Number")}
                  value={formData.bank_rfc}
                  onChange={handleInputChange}
                />
                <TextareaWithLabel
                  label={_t("concept", "Concept")}
                  name="bank_concept"
                  placeholder={_t("write_concept", "Write Concept")}
                  rows={3}
                  value={formData.bank_concept}
                  onChange={handleInputChange}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="cmn_card mt-3">
        <div className="bill_head d-flex gap-3 align-items-center">
          <div className="flex-grow-1">
            <h6 className="m-0">{_t("add_expenses", "Add Expenses")}</h6>
          </div>
          <div className="d-flex align-items-center gap-3">
            <h6 className="m-0">
              {_t("total_billable_amount", "Total Billable Amount:")}
              <strong className="totalPrice">
                ${formatNumber(totalAmount)}
              </strong>
            </h6>
          </div>
        </div>
        <div className="bill_head border-bottom-0">
          <div className="AddBill d-flex gap-3 align-items-center">
            <SelectBox
              className={"w-100"}
              label={_t("expense_type", "Expense Type")}
              name="expense_type"
              options={
                expenseTypes?.data?.map((expenseType) => ({
                  value: expenseType.name,
                  label: _t(expenseType.name),
                })) || []
              }
              value={currentExpense.expense_type}
              onChange={(e) =>
                setCurrentExpense((prev) => ({
                  ...prev,
                  expense_type: e.target.value,
                }))
              }
            />
            <InputWithLabel
              className={"w-100"}
              label={_t("description", "Description")}
              type="text"
              placeholder={_t("description", "Description")}
              value={currentExpense.description}
              onChange={(e) =>
                setCurrentExpense((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
            <InputWithLabel
              className={"w-100"}
              label={_t("amount", "Amount")}
              type="number"
              value={currentExpense.amount}
              onChange={(e) =>
                setCurrentExpense((prev) => ({
                  ...prev,
                  amount: e.target.value,
                }))
              }
              placeholder={"0"}
            />
            <Button
              label={
                editingIndex !== null
                  ? _t("update", "Update")
                  : _t("add", "Add")
              }
              onClick={addExpenseHandler}
            />
          </div>
        </div>
        <Datatable
          columns={columns}
          tableData={{ data: formData.expenses }}
          showPegination={false}
          showFilterButton={false}
          showCount={false}
          isLoading={isLoading}
        />
      </div>

      <div className="text-end pt-4">
        <Button
          label={
            isLoading
              ? _t("saving", "Saving...")
              : isEditMode
              ? _t("update_changes", "Update Changes")
              : _t("save_expense", "Save Expense")
          }
          disabled={isLoading}
          onClick={handleSaveChanges}
        />
      </div>
    </>
  );
};

export default Billcreation;
